var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-lead-profile" },
    [
      _c("bj-crud-form-modal", {
        ref: "crudModal",
        attrs: {
          "not-crud": "",
          model: "Lead",
          "endpoint-edit": "admin/leads",
          fields: _vm.editProfileFields
        },
        on: {
          saved: function($event) {
            _vm.fetchLead()
          }
        }
      }),
      _c("bj-add-inquiry-modal", {
        ref: "addInquiryModal",
        on: { added: _vm.reloadPage }
      }),
      _c("div", { staticClass: "row gutter-md" }, [
        _c(
          "div",
          { staticClass: "col-md-4 lead-sidebar" },
          [
            _c(
              "q-card",
              { staticClass: "full-height" },
              [
                _c(
                  "q-list",
                  {
                    staticClass: "scrollable-wrapper",
                    attrs: { separator: "" }
                  },
                  [
                    _c(
                      "q-collapsible",
                      {
                        attrs: {
                          opened: "",
                          label: "Info",
                          "collapse-icon": "keyboard_arrow_right",
                          "header-class": "collapsible-header"
                        }
                      },
                      [
                        _c("q-card-separator"),
                        _vm.lead
                          ? _c(
                              "q-card",
                              { attrs: { square: "", flat: "" } },
                              [
                                _c(
                                  "q-card-main",
                                  [
                                    _c(
                                      "q-item",
                                      { staticClass: "col-9" },
                                      [
                                        _c(
                                          "q-item-main",
                                          [
                                            _c(
                                              "q-item-tile",
                                              { attrs: { label: "" } },
                                              [
                                                _vm._v(
                                                  "\n                      Created At\n                    "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "q-item-tile",
                                              { attrs: { sublabel: "" } },
                                              [
                                                _c("SdDatetime", {
                                                  attrs: {
                                                    value: _vm.lead.created_at,
                                                    timezone:
                                                      _vm.propertyTimezone
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm.lead.phone_number
                                      ? _c(
                                          "q-item",
                                          { staticClass: "col-6" },
                                          [
                                            _c(
                                              "q-item-main",
                                              [
                                                _c(
                                                  "q-item-tile",
                                                  { attrs: { label: "" } },
                                                  [
                                                    _vm._v(
                                                      "\n                      Phone number\n                    "
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "q-item-tile",
                                                  { attrs: { sublabel: "" } },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.lead.phone_number
                                                        ) +
                                                        "\n                    "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.lead.email
                                      ? _c(
                                          "q-item",
                                          { staticClass: "col-6" },
                                          [
                                            _c(
                                              "q-item-main",
                                              [
                                                _c(
                                                  "q-item-tile",
                                                  { attrs: { label: "" } },
                                                  [
                                                    _vm._v(
                                                      "\n                      Email\n                    "
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "q-item-tile",
                                                  { attrs: { sublabel: "" } },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(_vm.lead.email) +
                                                        "\n                    "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.lead.notes
                                      ? _c(
                                          "q-item",
                                          { staticClass: "col-6" },
                                          [
                                            _c(
                                              "q-item-main",
                                              [
                                                _c(
                                                  "q-item-tile",
                                                  { attrs: { label: "" } },
                                                  [
                                                    _vm._v(
                                                      "\n                      Notes\n                    "
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "q-item-tile",
                                                  {
                                                    staticClass: "lead-notes",
                                                    attrs: { sublabel: "" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(_vm.lead.notes) +
                                                        "\n                    "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      "q-item",
                                      { staticClass: "col-auto" },
                                      [
                                        _c("q-btn", {
                                          staticClass: "q-mr-sm",
                                          attrs: {
                                            outline: "",
                                            rounded: "",
                                            size: "sm",
                                            label: "Edit",
                                            color: "black",
                                            icon: "edit"
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              var ref
                                              ;(ref =
                                                _vm.$refs.crudModal).open.apply(
                                                ref,
                                                ["edit"].concat(_vm.lead)
                                              )
                                            }
                                          }
                                        }),
                                        _c("q-btn", {
                                          attrs: {
                                            outline: "",
                                            rounded: "",
                                            size: "sm",
                                            label: "Add Inquiry",
                                            color: "green",
                                            icon: "add"
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              _vm.openInquiryModal(_vm.lead)
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "q-inner-loading",
                                      { attrs: { visible: _vm.loading } },
                                      [
                                        _c("q-spinner-puff", {
                                          attrs: {
                                            size: "50px",
                                            color: "primary"
                                          }
                                        }),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "q-mt-md text-primary text-bold"
                                          },
                                          [
                                            _vm._v(
                                              "\n                    Updating...\n                  "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm.inquiries
                      ? _c(
                          "q-collapsible",
                          {
                            attrs: {
                              opened: "",
                              label:
                                "Inquiries: (" + _vm.inquiries.length + ")",
                              "collapse-icon": "keyboard_arrow_right",
                              "header-class": "collapsible-header"
                            }
                          },
                          [
                            _c("q-card-separator"),
                            _c(
                              "q-card",
                              { attrs: { square: "", flat: "" } },
                              [
                                _c(
                                  "q-card-main",
                                  { staticClass: "inquiries-list" },
                                  _vm._l(_vm.inquiries, function(
                                    inquiry,
                                    index
                                  ) {
                                    return _c(
                                      "div",
                                      { staticClass: "inquiry-item" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "row text-left mb-2" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "col-4" },
                                              [
                                                _vm._v(
                                                  "\n                      Inquiry ID:\n                    "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "col-8" },
                                              [
                                                _c(
                                                  "router-link",
                                                  {
                                                    attrs: {
                                                      to: {
                                                        name:
                                                          "app.inquiries.timeline",
                                                        params: {
                                                          id: inquiry.id
                                                        }
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        #" +
                                                        _vm._s(inquiry.id) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "row text-left mb-2" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "col-4" },
                                              [
                                                _vm._v(
                                                  "\n                      Property address:\n                    "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "col-8" },
                                              [
                                                _c(
                                                  "router-link",
                                                  {
                                                    attrs: {
                                                      to: {
                                                        name:
                                                          "app.properties.combined",
                                                        params: {
                                                          id:
                                                            inquiry.property_id
                                                        }
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          inquiry.property_address
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                ),
                                                !inquiry.property_is_vacant
                                                  ? _c(
                                                      "q-chip",
                                                      {
                                                        staticStyle: {
                                                          "margin-left": "5px"
                                                        },
                                                        attrs: {
                                                          dense: "",
                                                          color: "yellow",
                                                          "text-color": "black"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        Occupied\n                      "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "row text-left mb-2" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "col-4" },
                                              [
                                                _vm._v(
                                                  "\n                      Created at:\n                    "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "col-8" },
                                              [
                                                _c("SdDatetime", {
                                                  attrs: {
                                                    value: inquiry.created_at,
                                                    timezone:
                                                      inquiry.property_timezone
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        inquiry.persona_identification_url
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "row text-left mb-2"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "col-4" },
                                                  [
                                                    _vm._v(
                                                      "\n                      Persona Inquiry:\n                    "
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "col-8" },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href:
                                                            inquiry.persona_identification_url,
                                                          target: "_blank"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        Open\n                      "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "div",
                                          { staticClass: "row text-left mb-2" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "col-8" },
                                              [
                                                inquiry.tour_status
                                                  ? _c("tour-status-chip", {
                                                      attrs: {
                                                        status: _vm.getHumanScheduleStatus(
                                                          inquiry.tour_status,
                                                          inquiry.is_taken_over
                                                        )
                                                      }
                                                    })
                                                  : _c(
                                                      "q-chip",
                                                      {
                                                        staticClass:
                                                          "tour-status-badge",
                                                        attrs: {
                                                          color:
                                                            inquiry.status ===
                                                            _vm.$config
                                                              .inquiryStatuses
                                                              .MATCHING_FAILED
                                                              ? "negative"
                                                              : ""
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.getHumanInquiryStatus(
                                                                inquiry.status
                                                              )
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    ),
                                                inquiry.uninterested_at
                                                  ? _c("q-icon", {
                                                      directives: [
                                                        {
                                                          name: "tippy",
                                                          rawName: "v-tippy"
                                                        }
                                                      ],
                                                      attrs: {
                                                        color: "negative",
                                                        name: "cancel",
                                                        title:
                                                          "Marked as uninterested"
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.checkPassGeolocation(
                                                        inquiry
                                                      )
                                                    )
                                                  )
                                                ])
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "col-auto" },
                                              [
                                                inquiry.status ===
                                                  _vm.$config.inquiryStatuses
                                                    .PENDING ||
                                                inquiry.status ===
                                                  _vm.$config.inquiryStatuses
                                                    .MATCHING_FAILED
                                                  ? _c("q-btn", {
                                                      directives: [
                                                        {
                                                          name: "tippy",
                                                          rawName: "v-tippy"
                                                        }
                                                      ],
                                                      staticClass: "q-mr-sm",
                                                      attrs: {
                                                        size: "sm",
                                                        rounded: "",
                                                        outline: "",
                                                        color: "black",
                                                        icon: "edit",
                                                        title: "Edit"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.openInquiryEditModal(
                                                            inquiry
                                                          )
                                                        }
                                                      }
                                                    })
                                                  : _vm._e(),
                                                inquiry.status ===
                                                  _vm.$config.inquiryStatuses
                                                    .PENDING &&
                                                !inquiry.uninterested_at
                                                  ? _c("q-btn", {
                                                      directives: [
                                                        {
                                                          name: "tippy",
                                                          rawName: "v-tippy"
                                                        }
                                                      ],
                                                      staticClass: "q-mr-sm",
                                                      attrs: {
                                                        size: "sm",
                                                        rounded: "",
                                                        outline: "",
                                                        color: "negative",
                                                        icon: "cancel",
                                                        title:
                                                          "Mark as uninterested"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.markAsUninterested(
                                                            inquiry
                                                          )
                                                        }
                                                      }
                                                    })
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        index !== _vm.inquiries.length - 1
                                          ? _c("q-card-separator", {
                                              staticClass: "mt-4 mb-4"
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  })
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "q-collapsible",
                      {
                        attrs: {
                          opened: "",
                          label:
                            "Identity History: (" +
                            _vm.leadIdentityHistory.length +
                            ")",
                          "collapse-icon": "keyboard_arrow_right",
                          "header-class": "collapsible-header"
                        }
                      },
                      [
                        _c("q-card-separator"),
                        _c(
                          "q-card",
                          { attrs: { square: "", flat: "" } },
                          [
                            _vm.leadIdentityHistory.length
                              ? _c(
                                  "q-card-main",
                                  [
                                    _c("SdLeadIdentityHistoryTimeline", {
                                      attrs: {
                                        "identity-history":
                                          _vm.leadIdentityHistory,
                                        "display-inquiry-link": true
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm.lead
          ? _c(
              "div",
              { staticClass: "col-md-8 col-xs-12" },
              [
                _c(
                  "q-card",
                  {
                    ref: "timeline",
                    staticClass: "full-height",
                    attrs: { id: "timeline" }
                  },
                  [
                    _c(
                      "q-card-main",
                      { staticClass: "relative-position scrollable-wrapper" },
                      _vm._l(_vm.activitiesByDays, function(
                        activityByDay,
                        date,
                        index
                      ) {
                        return !_vm.loading
                          ? _c(
                              "div",
                              { key: index },
                              [
                                _c(
                                  "q-chip",
                                  {
                                    staticClass: "event-date-chip",
                                    attrs: {
                                      dense: "",
                                      color: "blue",
                                      "text-color": "white"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(date) +
                                        "\n            "
                                    )
                                  ]
                                ),
                                _vm._l(activityByDay, function(activity) {
                                  return _c(
                                    "div",
                                    { staticClass: "event-wrapper" },
                                    [
                                      activity.type === "INQUIRY_CREATED"
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "text-center generic-event"
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.dateInHumanFormat(
                                                      activity.date
                                                    )
                                                  ) +
                                                  " New inquiry at "
                                              ),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    activity.property_address
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        : _vm._e(),
                                      activity.type === "TOUR_SCHEDULED"
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "text-center generic-event"
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.dateInHumanFormat(
                                                      activity.date
                                                    )
                                                  ) +
                                                  " Tour scheduled at "
                                              ),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    activity.property_address
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        : _vm._e(),
                                      activity.type === "TOUR_NO_SHOW"
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "text-center generic-event"
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.dateInHumanFormat(
                                                      activity.date
                                                    )
                                                  ) +
                                                  " Tour resulted in no show at "
                                              ),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    activity.property_address
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        : _vm._e(),
                                      activity.type === "TOUR_TECHNICAL_ISSUE"
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "text-center generic-event"
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.dateInHumanFormat(
                                                      activity.date
                                                    )
                                                  ) +
                                                  " Tour resulted in technical issue at\n                "
                                              ),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    activity.property_address
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        : _vm._e(),
                                      activity.type === "TOUR_CANCELLED"
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "text-center generic-event"
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.dateInHumanFormat(
                                                      activity.date
                                                    )
                                                  ) +
                                                  " Tour was cancelled at "
                                              ),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    activity.property_address
                                                  )
                                                )
                                              ]),
                                              _vm._v(
                                                "\n                Reason: " +
                                                  _vm._s(
                                                    _vm.getHumanScheduleStatus(
                                                      activity.status,
                                                      false
                                                    )
                                                  ) +
                                                  "\n              "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      activity.type === "TOUR_COMPLETED"
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "text-center generic-event"
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.dateInHumanFormat(
                                                      activity.date
                                                    )
                                                  ) +
                                                  " Tour was completed at "
                                              ),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    activity.property_address
                                                  )
                                                )
                                              ]),
                                              _vm._v(".\n                "),
                                              activity.survey_result_id
                                                ? _c(
                                                    "router-link",
                                                    {
                                                      attrs: {
                                                        to: {
                                                          name:
                                                            "app.tours.survey-result",
                                                          params: {
                                                            id:
                                                              activity.survey_result_id
                                                          }
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                  Go to review\n                "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      activity.type === "OUTGOING_MESSAGE"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "outgoing-message-wrapper"
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticStyle: {
                                                    color: "#59B380"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(activity.causer) +
                                                      "\n                "
                                                  )
                                                ]
                                              ),
                                              _c("p", [
                                                _vm._v(_vm._s(activity.message))
                                              ]),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.dateInHumanFormat(
                                                      activity.date
                                                    )
                                                  ) + " "
                                                )
                                              ])
                                            ]
                                          )
                                        : _vm._e(),
                                      activity.type === "INCOMING_MESSAGE"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "incoming-message-wrapper"
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticStyle: {
                                                    color: "#41A5F5"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.lead.full_name
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              ),
                                              _c("p", [
                                                _vm._v(_vm._s(activity.message))
                                              ]),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.dateInHumanFormat(
                                                      activity.date
                                                    )
                                                  ) + " "
                                                )
                                              ])
                                            ]
                                          )
                                        : _vm._e(),
                                      activity.type === "DISQUALIFIED"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "disqualified-wrapper"
                                            },
                                            [
                                              _c("p", [
                                                _vm._v(
                                                  "\n                  Lead disqualified\n                  "
                                                ),
                                                _c(
                                                  "small",
                                                  [
                                                    _vm._v(
                                                      "\n                    (\n                    "
                                                    ),
                                                    _c(
                                                      "router-link",
                                                      {
                                                        attrs: {
                                                          to: {
                                                            name:
                                                              "app.inquiries.timeline",
                                                            params: {
                                                              id:
                                                                activity.inquiry_id
                                                            }
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      #" +
                                                            _vm._s(
                                                              activity.inquiry_id
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(
                                                      "\n                    - " +
                                                        _vm._s(
                                                          activity.property_address
                                                        ) +
                                                        ")\n                  "
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]),
                                              _c("div", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    activity.message
                                                  )
                                                }
                                              }),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.dateInHumanFormat(
                                                      activity.date
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          : _vm._e()
                      })
                    ),
                    _c("q-card-separator"),
                    _c("q-card-main", { staticClass: "row gutter-xs" }, [
                      _c(
                        "div",
                        { staticClass: "col-11" },
                        [
                          _c(
                            "q-field",
                            [
                              _c("q-input", {
                                attrs: {
                                  inverted: "",
                                  placeholder: "Type a message to the lead"
                                },
                                nativeOn: {
                                  keyup: function($event) {
                                    if (
                                      !("button" in $event) &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    _vm.sendTextToLead()
                                  }
                                },
                                model: {
                                  value: _vm.textMessageToLead,
                                  callback: function($$v) {
                                    _vm.textMessageToLead = $$v
                                  },
                                  expression: "textMessageToLead"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-1" },
                        [
                          _c("q-btn", {
                            attrs: {
                              disabled:
                                _vm.textMessageToLead === "" ||
                                _vm.smsIsSending,
                              rounded: "",
                              size: "md",
                              label: "Send",
                              "no-caps": ""
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                _vm.sendTextToLead()
                              }
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }